import React from "react";

export interface IIconCalendar {}

export default function IconCalendar() {
  return (
    <svg
      className="h-6 w-6"
      preserveAspectRatio="none"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6 5H6.4C4.52223 5 3 6.49238 3 8.33333V16.6667C3 18.5076 4.52223 20 6.4 20H16.6C18.4778 20 20 18.5076 20 16.6667V8.33333C20 6.49238 18.4778 5 16.6 5Z"
        className="stroke-brij-Peach"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M8 3V6"
        className="stroke-brij-Peach"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M15 3V6"
        className="stroke-brij-Peach"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M3 10H20"
        className="stroke-brij-Peach"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
}
